import PropTypes from "prop-types";

export function authAccess_Page(page, auth) {
  let response = { read: false, edit: false };
  if (page === "report") page = "raport";
  switch (page) {
    case "koti": // Kotisivu /koti
      return auth.page.koti;
    case "list": // Tilauslista /list
      return auth.page.list;
    case "grid": // Tilauskalenteri /grid
      return auth.page.grid;
    case "raport": // Raportit /raport
      return auth.page.report;
    case "raport_dash": // Raportit /raport dash
      return auth.page.report.stats.dash;
    case "raport_lasku": // Raportit /raport laskustat
      return auth.page.lasku;
    case "raport_pumppari": // Raportit /raport pumppari
      return auth.report.daily.vehicle.read;
    case "liite": // Liitetiedostot /liite
      return auth.page.liite.list;
    case "haku": // Haku /haku
      return auth.page.haku;
    case "tyot": // Työt /tyot
      return auth.page.tyot;
    case "admin": // Admin /admin
      return auth.page.admin;
    case "profile": // Profiili /profile
      return auth.page.profile;
    case "tarjous": // Tarjous /tarjous
      return auth.page.tarjous;
    case "loma": // Lomat /loma
      return auth.page.loma;
    case "common": // darkmode setting etc
      return { read: true, edit: true };
    case "pumiFi":
      if (auth.userAsiakas?.asiakasId === 8 && auth.user.isAnyAdmin)
        return { read: true, edit: true };
      return response;
    case "ai":
      return { read: auth.page.ai.read, edit: auth.page.ai.read };
    default:
      console.log("authAccess denied: page not defined", page);
      return response;
  }
}

authAccess_Page.propTypes = {
  page: PropTypes.string,
  user: PropTypes.object,
  userAsiakas: PropTypes.object,
};
